import React from "react";
import styles from "./ScoreDelta.module.css";

interface ScoreDeltaProps {
  scoreBefore: number;
  scoreAfter: number;
  caption?: string;
}

export default function ScoreDelta({ scoreBefore, scoreAfter, caption }: ScoreDeltaProps) {
  const delta = scoreAfter - scoreBefore;
  const positive = delta >= 0;

  return (
    <div className={styles.card}>
      <div className={styles.leftCol}>
        <p className={styles.label}>SCORE IMPROVED</p>
        <p className={styles.numbers}>
          <span className={styles.before}>{scoreBefore}</span>
          <span className={styles.arrow}>→</span>
          <span className={styles.after}>{scoreAfter}</span>
        </p>
      </div>
      <div className={`${styles.pill} ${positive ? styles.pillPositive : styles.pillNegative}`}>
        <p className={styles.delta}>
          {positive ? "+" : ""}
          {delta} PTS
        </p>
        {caption && <p className={styles.deltaSub}>{caption}</p>}
      </div>
    </div>
  );
}
